export default __webpack_public_path__ + "static/media/illustration-intro.c20d8525.png";